// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Colors } from '@zapier/design-system';
import { SignUpForm } from '@zapier/authentication';
import { urlWithNext } from '@zapier/url-utils';

import Config from 'app/common/Config';
import LinkPreserveParamsContainer from 'app/common/components/LinkPreserveParamsContainer';
import ZapierAuthenticationContainer from 'app/login/components/ZapierIdentityAuth/ZapierAuthenticationContainer';
import { PLATFORM_LOGIN_URL } from 'app/login/constants';

const bem = bemify('zapier-authentication');

const ZapierAuthenticationSignUp = () => {
  return (
    <ZapierAuthenticationContainer>
      {({ invitation, isPlatformPage, queryParameters, routeTo }) => {
        const next =
          queryParameters.next || (isPlatformPage ? PLATFORM_LOGIN_URL : null);
        const loginBaseUrlBase = isPlatformPage ? '/platform' : '/app';
        const loginUrl = urlWithNext(`${loginBaseUrlBase}/login`, next);
        const selectedApis = queryParameters.selected_apis;
        const useCaseSlug = queryParameters.use_case;

        return (
          <React.Fragment>
            <SignUpForm
              enableEmailAutoFocus={true}
              googleCaptchaSiteKey={Config.googleCaptchaSiteKey}
              googleClientId={Config.googleClientId}
              invitation={invitation}
              next={next}
              routeTo={routeTo}
              selectedApis={selectedApis}
              useCase={useCaseSlug}
            />
            <p className={bem('__footer')}>
              Already have an account?{'\u00A0'}
              <LinkPreserveParamsContainer
                href={loginUrl}
                kind="blue"
                style={{ color: Colors.blue }}
              >
                Log In
              </LinkPreserveParamsContainer>
            </p>
          </React.Fragment>
        );
      }}
    </ZapierAuthenticationContainer>
  );
};

export default ZapierAuthenticationSignUp;
